<template>
  <v-dialog v-model="isUploadDialogOpen" max-width="900px" persistent>
    <v-card>
      <v-card-title>
        <h5>View Images</h5>
      </v-card-title>
      <v-card-text>
        <v-container class="fill-height" fluid style="min-height: 434px">
          <v-fade-transition mode="out-in">
            <v-row>
              <template v-for="attachment in service">
                <v-col cols="12" sm="12" md="6" :key="attachment._id">
                  <v-card>
                    <v-img
                      :src="attachment.AWSLink"
                      :lazy-src="attachment.AWSLink"
                      height="300"
                      class="grey lighten-2"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>

                      <v-chip color="pink" label text-color="white">
                        <v-icon left>
                          mdi-label
                        </v-icon>
                        <a :href="attachment.Category" class="white--text">{{
                          attachment.Category
                        }}</a>
                      </v-chip>
                    </v-img>
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </v-fade-transition>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="bg-color mb-3 mt-n4" dark color="red" @click="close">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */

export default {
  data() {
    return {
      isUploadDialogOpen: false,
      service: {},
    };
  },
  methods: {
    openDialog(serv) {
      this.service = {}
      if (serv?.Attachments?.length > 0) {
        this.service = serv.Attachments.map((item) => {
          let category = item.Category.replace(/^Skin Check -\s*/, "");
          return {
            AWSLink: item.AWSLink,
            Category: category
              .replace(/^[a-z]/, function(m) {
                return m.toUpperCase();
              })
              .replace(/([a-z])([A-Z])/g, "$1 $2"),
          };
        });
      }
      this.isUploadDialogOpen = !this.isUploadDialogOpen;
    },
    close() {
      this.isUploadDialogOpen = !this.isUploadDialogOpen;
    },
  },
};
</script>
